export default "__VITE_ASSET__C950VvJZ__"